import { render, staticRenderFns } from "./CommissionBarChart.vue?vue&type=template&id=0d039db1"
import script from "./CommissionBarChart.vue?vue&type=script&lang=js"
export * from "./CommissionBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports